import {makeAutoObservable, toJS} from "mobx";
import {toastUtils} from "../../../common/utils/Toastutils";
import {productInPosCartStore} from "../productInPos/ProductInPosCartStore";
import {paymentService} from "./PaymentService";
import StorageService from "../../../common/service/StorageService";
import {HttpStatusCode} from "axios";
import {productInPostStore} from "../productInPos/ProductInPostStore";
import {vendorSmartPos} from "../../../common/constants/Constants";

class PaymentPosStore{
    isSave: boolean = false
    isSaveConfirm: boolean = false;
    isCreateSmartPos: boolean = false;
    isLoading: boolean = false
    posid: string | undefined
    isModalNoteOpen: boolean = false
    isModalImageQrOpen: boolean = false
    timeLeft:number = 300 // thời gian đếm ngược
    priceTotal: number = 0 // Tổng tiền thanh toán
    priceTotalAfterPayment: number = 0 // Tổng tiền còn lại sau khi thanh toán
    pricePayment: number = 0 // Tổng tiền còn lại sau khi thanh toán
    imageQr: string = '' // Tổng tiền còn lại sau khi thanh toán
    idPayTypeActive:number = 0;
    listPayType: any = []
    notePos: string | null | undefined;
    imageBank: string | null | undefined ;
    typePayment: string = '' //Thanh toán bằng tiền mặt/chuyển khoản hoặc smart pos
    isModalSmartPos: boolean = false
    isModalSmartPosLoading: boolean = false
    isShowButtonConfirm: boolean = false
    dataSmartPos: any

    staticParamPaymenSmartPos :{amount: number, machine_pos_id: number|undefined, payment_type: string} = {
        amount: 0,
        machine_pos_id: undefined,
        payment_type: '',
    }
    constructor() {
        makeAutoObservable(this)
    }
    showModalNote = () => {
        this.isModalNoteOpen = true;
    };
    handleCancelNote = () => {
        this.isModalNoteOpen = false;
    };
    showModalImageQr = () => {
        this.isModalImageQrOpen = true;
    };
    handleCancelImageQr = () => {
        this.isModalImageQrOpen = false;
    };

    handleSetFileImageBank = (pathFile: string) => {
        this.imageBank = pathFile;
    };
    handleRemoveImageBank = () => {
        this.imageBank = '';
    };

    /**
     *
     * @param type // 1: là tiền mặt. 2: là chuyển khoản, 3: là máy quẹt thẻ Smart POS
     * @description Thêm kiểu thanh toán
     */
    handlePushPayType = (type:number) => { // 1: là tiền mặt. 2: là chuyển khoản, 3: là máy quẹt thẻ Smart POS
        let idPayType = Date.now();
        const data = {
            id : idPayType,
            price: this.priceTotalAfterPayment,
            type: type,
            close: 1, // 1 là xóa hết 1 lần, 2 là xóa lần lượt
        }
        this.idPayTypeActive = idPayType;
        this.listPayType.unshift(data)
        this.handlePricePayment()
    };
    /**
     *
     * @param id
     * @description Xóa kiểu thanh toán
     */
    handleRemovePayType = (id:number) => {
        this.listPayType = this.listPayType.filter((item:any) => item.id != id)
        this.handlePricePayment();
        if(this.listPayType.length === 0){
            this.typePayment = ''
        }
    };

    /**
     * @description Tổng tiền thanh toán
     */
    handlePricePayment = () => {
        this.pricePayment = 0
        this.listPayType.forEach((item:any) =>{
            this.pricePayment += item.price
        })
        if(this.priceTotal - this.pricePayment > 0){
            this.priceTotalAfterPayment = this.priceTotal - this.pricePayment;
        }else{
            this.priceTotalAfterPayment = 0;
        }
    }
    /**
     *
     * @param idPayType
     * @param numberPay
     * @description Thao tác bàn phím
     */
    handleNumber = (idPayType:number,numberPay:number) => {
        this.listPayType = this.listPayType.map((item:any) => {
            if(item.id === idPayType){
                if(item.close === 1){
                    item.price = numberPay;
                    item.close = 2;
                }else{
                    item.price = parseInt(String(item.price) + String(numberPay));
                }
            }
            return item;
        })
        this.handlePricePayment();
    }
    handleRemove = (idPayType:number) => {
        this.listPayType = this.listPayType.map((item:any) => {
            if(item.id === idPayType){
                item.price = 0;
                item.close = 2;
            }
            return item;
        })
        this.handlePricePayment();
    }

    async generateQr(){
        if(this.isSave === false){
            this.isSave = true
            var bank_amount = 0;
            this.listPayType.filter((item:any) => item.type === 2).map((item:any) => bank_amount += item.price)
            const params = {
                description: 'Thanh toán tiền',
                money: bank_amount
            }
            const result = await paymentService.fetchGenerateQr(params);
            this.isSave = false
            if (result.status === HttpStatusCode.Ok) {
                this.imageQr = result.body?.qr ? result.body.qr : ''
                this.showModalImageQr()
            } else{
                this.showModalImageQr()
            }
        }
    }
    async fetchSaveOrderPosEcommerce(navigate: (route: string) => void){
        if(this.isSave === false){
            this.isSave = true
            var bank_amount = 0;
            var cash_amount = 0;
            var customer_id =  productInPosCartStore?.dataCustomer?.id ? productInPosCartStore.dataCustomer.id : null

            this.listPayType.filter((item:any) => item.type === 1).map((item:any) => cash_amount += item.price)
            this.listPayType.filter((item:any) => item.type === 2).map((item:any) => bank_amount += item.price)

            const params = {
                note: this.notePos,
                pos_id: this.posid,
                transaction_pos_id: productInPostStore.dataPosMachine.pos_session_id,
                image_bank: this.imageBank,
                session_data: {
                    customer_id:customer_id,
                    bank_amount: bank_amount,
                    cash_amount: cash_amount,
                    wallet_amount: 0,
                },
                cart_items:productInPosCartStore.dataListProInCart.map((item:any) =>
                    {
                        return {
                            product_id: item.productId,
                            qty: item.quantity,
                            variant_id: item.variant.id,
                            discount: item.discount,
                            price: item.price
                        }
                    }
                )
            }
            const result = await paymentService.fetchSaveOrderPosEcommerce(params);
            this.isSave = false
            if (result.status === HttpStatusCode.Ok) {
               this.clearOrder()
                navigate(`/pos/thanh-cong/${result.body.id}`);
            }
            else{
                toastUtils.error('Đã có lỗi xảy ra!', '');
            }
        }

        // this.openModal = false;
    }
    async fetchCreateNewPaymentPos(){
        if(this.isCreateSmartPos === false){
            this.isCreateSmartPos = true
            paymentPosStore.isModalSmartPosLoading = true
            let {amount,machine_pos_id,payment_type} = this.staticParamPaymenSmartPos
            this.listPayType.filter((item:any) => item.type === 3).map((item:any) => amount += item.price)
            let smartPosItem = productInPostStore.dataPosMachine.smart_pos.find((item: any) => item.id === machine_pos_id);
            let idVendorSmartPos = smartPosItem?.vendor_name; // Use optional chaining to prevent errors
            let type = vendorSmartPos.find((item: any) => item.id === idVendorSmartPos)?.type || 'mpos';
            let smart_amount = 0;
            this.listPayType.filter((item:any) => item.type === 3).map((item:any) => smart_amount += item.price)
            var customer_id =  productInPosCartStore?.dataCustomer?.id ? productInPosCartStore.dataCustomer.id : null
            const params = {
                amount: smart_amount,
                note: this.notePos,
                machine_pos_id: machine_pos_id,
                payment_type: payment_type,
                data_order: {
                    note: this.notePos,
                    pos_id: this.posid,
                    transaction_pos_id: productInPostStore.dataPosMachine.pos_session_id,
                    image_bank: this.imageBank,
                    session_data: {
                        customer_id:customer_id,
                        bank_amount: smart_amount,
                        cash_amount: 0,
                        wallet_amount: 0,
                    },
                    cart_items:productInPosCartStore.dataListProInCart.map((item:any) =>
                        {
                            return {
                                product_id: item.productId,
                                qty: item.quantity,
                                variant_id: item.variant.id,
                                discount: item.discount,
                                price: item.price
                            }
                        }
                    )
                },
            }
            const result = await paymentService.fetchCreateNewPaymentPos(params,type);
            this.isCreateSmartPos = false
            if (result.status === HttpStatusCode.Ok) {
                this.dataSmartPos = result.body
                this.timeLeft = 299
                this.isShowButtonConfirm = false
                setTimeout(() => {
                    this.isShowButtonConfirm = true;
                }, 30000); // sau 30 giây
            } else{
                paymentPosStore.isModalSmartPosLoading = false
                if(result.body.message.amount === 'the_amount_must_be_at_least_3000'){
                    toastUtils.warning("Số tiền thanh toán phải lớn hơn 3.000đ", "")
                } else if ('internal_server_error'){
                    toastUtils.warning("Máy Smart POS cấu hình chưa chính xác", "")
                }else{
                    toastUtils.error("Đã có lỗi xảy ra", "")
                }

            }
        }
    }
    async fetchCancelPaymentPos(navigate: (route: string) => void){
        if(this.isSave === false){
            this.isSave = true
            let smartPosItem = productInPostStore.dataPosMachine.smart_pos.find((item: any) => item.id === this.staticParamPaymenSmartPos.machine_pos_id);
            let idVendorSmartPos = smartPosItem?.vendor_name; // Use optional chaining to prevent errors
            let type = vendorSmartPos.find((item: any) => item.id === idVendorSmartPos)?.type || 'mpos';

            let smart_amount = 0;
            this.listPayType.filter((item:any) => item.type === 3).map((item:any) => smart_amount += item.price)

            const params = {
                amount: smart_amount,
                machine_pos_id: this.staticParamPaymenSmartPos.machine_pos_id,
                order_id: this.dataSmartPos.orderId,
            }
            const result = await paymentService.fetchCancelPaymentPos(params,type);
            this.isSave = false
            paymentPosStore.isModalSmartPosLoading = false
            if (result.status === HttpStatusCode.Ok) {
                this.dataSmartPos = {}
            } else{
                if(result.body.message.exception === 'thanh_toán_lỗi_do_hóa_đơn_đã_được_thanh_toán_từ_trước'){
                    toastUtils.warning("Đơn hàng đã được thanh toán !", "")
                    this.clearOrder()
                    navigate(`/pos/${this.posid}/san-pham`);
                }else {
                    toastUtils.error("Đã có lỗi xảy ra", "")
                }

            }
        }
    }

    async fetchMposManualCallback(navigate: (route: string) => void){
        if(this.isSaveConfirm === false){
            this.isSaveConfirm = true
            const params = {
                machine_pos_id: this.staticParamPaymenSmartPos.machine_pos_id,
                order_id: this.dataSmartPos.orderId,
            }
            const result = await paymentService.fetchMposManualCallback(params);
            this.isSaveConfirm = false
            if (result.status === HttpStatusCode.Ok) {
               this.clearOrder()
                navigate(`/pos/thanh-cong/${result.body.transactionId}`);
            } else{
                this.isModalSmartPosLoading = true
                if(result.body.message.error === 'order_not_paid_yet'){
                    toastUtils.warning("Đơn hàng chưa được thanh toán", "")
                }else{
                    toastUtils.error("Đã có lỗi xảy ra", "")
                }

            }
        }
    }
    async clearOrder(){
        StorageService.removeLocalStore(`cartPos${this.posid}`)
        StorageService.removeLocalStore(`notePos${this.posid}`)
        StorageService.removeLocalStore(`customerPos${this.posid}`)
        StorageService.removeLocalStore(`uploadedImageBank`)
        this.listPayType = []
        this.handleCancelImageQr()
        productInPosCartStore.dataCustomer = null
        this.notePos = ''
        this.typePayment = ''
        productInPosCartStore.dataListProInCart = []
        productInPostStore.dataProduct = []
        this.isModalSmartPosLoading = false
        this.isModalSmartPos = false
    }
}

export const paymentPosStore = new PaymentPosStore()